import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { alignItems, inlineFlexbox, justifyContent, flexbox, flexDirection } from '../../styles/helpers/flexbox';

const ModalBody = styled.div`

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .doughnuts-questions-block {
    ${flexbox()}
    ${flexDirection('row')}
    ${justifyContent('space-between')}

    margin-bottom: 40px;
  }
`;

const TAB_HEADING_HEIGHT = 35;

const ModalContent = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

const TabbedPanel = styled.section((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    border: 1px solid ${colours.grey[400]};
    border-radius: 8px;
    width: 100%;
    height: calc(100% - ${TAB_HEADING_HEIGHT}px);
    margin-top: ${TAB_HEADING_HEIGHT}px;
    box-sizing: border-box;
  `;
});

const TabHeading = styled.h2((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    font-size: 16px;
    font-weight: normal;
    background-color: #fff;
    border: 1px solid ${colours.grey[400]};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    ${props.selected ? 'border-bottom: 3px solid #fff;' : ''}
    cursor: ${props.selected ? 'default' : 'pointer'};
    ${props.disabled ? 'pointer-events: none;' : ''}
    transform: translateY(-100%);
    height: ${TAB_HEADING_HEIGHT}px;
    ${inlineFlexbox()}
    ${alignItems('center')}
    ${justifyContent('center')}
    padding: 5px 10px;
    box-sizing: border-box;
    min-width: 125px;

    &:not(:last-child) {
      margin-right: 10px;
    }

    div[class*='svgIconComponent--'] {
      width: auto;
      margin-right: 5px;
      
      path {
        fill: #3C4E5E;
      }
    }
  `;
});

const TabContent = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    transform: translateY(-${TAB_HEADING_HEIGHT}px);
    word-wrap: break-word;
    overflow-y: scroll;
    padding-top: 10px;
    box-sizing: border-box;
    height: 100%;

    > * {
      margin-left: 25px;
      margin-right: 25px;
    }
  
    > hr {
      margin-top: 10px;
      margin-bottom: 10px;
      border: none;
      border-top: 1px solid ${colours.grey[400]};
    }
  `;
});

export { ModalBody, ModalContent, TabbedPanel, TabHeading, TabContent };
